module.exports = __webpack_public_path__ + "static/headerRightBg375-1ff77e33f874f472b9c2eba4cb5b5ee4.png";